import { useEffect, useMemo, useRef } from 'react';

import { CoordinationClient } from '@atlassiansox/engagekit-ts';

import { CancellablePromise } from '@atlassian/dynamic-cards-search-client';

import { SPOTLIGHT_MESSAGE_ID } from '../../common/constants/spotlight';
import { useCloudId } from '../../controllers/store';
import { useSpotlightState } from '../../controllers/store/spotlight';

export const useSpotlightPrefetch = (): void => {
	const [cloudId] = useCloudId();
	const [spotlight, { start, end }] = useSpotlightState();

	const requestRef = useRef<CancellablePromise<boolean>>();

	const coordinationClient = useMemo(() => {
		if (!cloudId || cloudId === '') {
			return {
				start: (_: string) => Promise.resolve(false),
				stop: (_: string) => Promise.resolve(false),
			};
		}

		const client = new CoordinationClient({
			cloudId,
			stargateUrl: '/gateway/api',
		});

		return client;
	}, [cloudId]);

	useEffect(() => {
		if (requestRef.current) {
			return;
		}

		requestRef.current = new CancellablePromise(coordinationClient.start(SPOTLIGHT_MESSAGE_ID));

		requestRef.current
			.promise()
			.then((displaySpotlight) => {
				displaySpotlight ? start() : end();
			})
			.catch((_) => {
				end();
			});

		// The network request for the spotlight exposure should only ever be called once.
		// Otherwise, it will cause conflicts and the spotlight will never be rendered.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (spotlight.state === 'dismiss') {
			coordinationClient.stop(SPOTLIGHT_MESSAGE_ID);
		}
	}, [coordinationClient, spotlight.state]);
};
